
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class ImageSelector extends Vue {
  @Prop({default: false}) disabled: boolean;
  @Prop({ default: () => [] }) value!: (File | string)[]
  @Prop({ default: 'Subir Imágenes' }) label!: string;
  localFiles: (File | string)[] = [];

  @Watch('value', { immediate: true, deep: true })
  onValueChanged(newVal: (File | string)[]) {
    this.localFiles = [...newVal];
  }

  triggerInput() {
    (this.$refs.input as HTMLInputElement).click()
  }

  handleFiles(event: Event) {
    const target = event.target as HTMLInputElement
    const files = target.files
    if (files && files.length) {
      const newFiles = Array.from(files)
      this.localFiles = [...this.localFiles, ...newFiles]
      this.emitChange()
    }
    this.$refs.input && ((this.$refs.input as HTMLInputElement).value = '')
  }
  removeImage(index: number) {
    this.localFiles = this.localFiles.filter((_, i) => i !== index)
    this.emitChange();
  }

  getImageUrl(img: File | string): string {
    return typeof img === 'string' ? img : URL.createObjectURL(img)
  }

  emitChange() {
    this.$emit('input', this.localFiles)
    this.$emit('change', this.localFiles)
  }
}
